export * from './points-score';
export * from './score-if';
